export default __webpack_public_path__ + "static/media/theme.51785230.svg";